/* eslint-disable react/prop-types */
import React from 'react';

const TONE = {
  STEWARDED:                'bg-emerald-50 text-emerald-800 border-emerald-300',
  FLOWING:                  'bg-sky-50      text-sky-800     border-sky-200',
  STRAINING:                'bg-amber-50    text-amber-800   border-amber-200',
  RESTORATION_RECOMMENDED:  'bg-stone-100   text-stone-700   border-stone-300',
};

const LABEL = {
  STEWARDED:               'Stewarded',
  FLOWING:                 'Flowing',
  STRAINING:               'Straining',
  RESTORATION_RECOMMENDED: 'Restoration recommended',
};

export default function PostureBadge({ posture, compact = false }) {
  if (!posture) return null;
  const code = posture.code || posture;
  const tone = TONE[code] || TONE.RESTORATION_RECOMMENDED;
  return (
    <span
      data-testid={`posture-badge-${code}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[10px] uppercase tracking-[0.16em] ${tone}`}
    >
      <span className="w-1 h-1 rounded-full bg-current opacity-70" />
      {LABEL[code] || code}
      {!compact && posture.description && (
        <span className="opacity-60 normal-case tracking-normal ml-1">· {posture.description}</span>
      )}
    </span>
  );
}
